<template>
  <div class="section-signup bg1-pattern p-t-35 p-b-35">
    <div class="flex-c-m flex-w flex-col-c-m-lg p-l-5 p-r-5">
      <span class="txt5 m-10">{{ $t("column.getNews") }}</span>
      <div class="wrap-input-signup size17 bo2 bo-rad-10 bgwhite pos-relative txt10 m-10">
        <input
          class="bo-rad-10 sizefull txt10 p-l-20"
          type="text"
          name="email-address"
          placeholder="Email Adrress"
          v-model="email"
        >
        <i class="fa fa-envelope ab-r-m m-r-18" aria-hidden="true"></i>
      </div>
      <button v-on:click="showAlert" class="btn3 flex-c-m size18 txt11 trans-0-4 m-10">{{ $t("column.subscribe") }}</button>
    </div>
  </div>
</template>

<style scoped >
</style>
<script >
export default {
  name: "Subscribe",
  data() {
    return {
      email: ""
    };
  },
  methods: {
    showAlert() {
      let pushEmail = firebaseDB.ref(
        "subscribe"
      );

      if (
        !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.email)
      ) {
        this.$swal.fire({
          position: "top",
          type: "error",
          title: "Oops...",
          text: "email格式錯誤!"
        });
      }
      else{

      this.$swal(`感謝您的訂閱！您的email為: ${this.email}`);
      pushEmail.push(this.email);
      this.email = "";

      }

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Subscribe.vue